import type { JSX } from 'react';
import React from 'react';

import type { IPerson } from '@feathr/blackbox';

import type { ISelectSingleValueProps } from '../SelectOptions.types';
import SelectSingleValue from '../SelectSingleValue';
import PersonContents from './PersonContents';

function PersonSingleValue<T extends IPerson>(
  props: Readonly<ISelectSingleValueProps<T>>,
): JSX.Element {
  const { data } = props;

  return (
    <SelectSingleValue {...props}>
      <PersonContents data={data} size={'small'} />
    </SelectSingleValue>
  );
}

export default PersonSingleValue;
